export class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
    }
  }
}

export class OverflowList extends DeclarativeShadowElement {
  connectedCallback() {
    super.connectedCallback();
    this.style.setProperty('--overflow-count', '0');
  }
}

function syncHeaderHeightFromCSS() {
  // Juste s'assurer que la variable existe, sans lire le layout
  document.body.style.setProperty('--header-height-ready', '1');
}

function updateTransparentHeaderOffset() {
  const header = document.getElementById('header-component');
  const headerGroup = document.getElementById('header-group');

  if (!headerGroup || !header || !header.hasAttribute('transparent')) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }

  const headerSection = headerGroup.firstElementChild;
  const shouldApplyOffset =
    headerSection?.classList.contains('header-section') &&
    !headerSection.nextElementSibling?.classList.contains('shopify-section')
      ? '1'
      : '0';

  document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
}

function updateAllHeaderCustomProperties() {
  syncHeaderHeightFromCSS();
  updateTransparentHeaderOffset();
}

// Lance après que la page soit totalement chargée
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    requestIdleCallback(updateAllHeaderCustomProperties, { timeout: 500 });
  });
} else {
  requestIdleCallback(updateAllHeaderCustomProperties, { timeout: 500 });
}
